module.exports = __webpack_public_path__ + "img/Speaker=Bernard Moon.e0764fde.png";